import type { editProperties, editedPageProperties } from 'reduxStore/edit/types'
import type { Proposal } from 'reduxStore/quote/types'
import { action } from 'typesafe-actions'
import { ActionTypes } from './constants'
import type { DrawingSet, Project, ProjectFolder, ProjectsState, drawingPage } from './types'

export const setErrorMessage = (message: ProjectsState['error']) => {
  return action(ActionTypes.SET_ERROR_MESSAGE, {
    message,
  })
}

export const setSuccessMessage = (message: ProjectsState['actionMessage']) => {
  return action(ActionTypes.SET_SUCCESS_MESSAGE, {
    message,
  })
}

export const setProFeatureError = (featureName: string) => {
  console.log(`Setting pro feature error for feature: ${featureName}`)
  return action(ActionTypes.SET_PRO_FEATURE_ERROR, {
    featureName,
  })
}

export const clearProFeatureError = () => {
  return action(ActionTypes.CLEAR_PRO_FEATURE_ERROR, {})
}
export const getProposalsSuccess = (proposals: Proposal[]) => {
  return action(ActionTypes.SET_PROPOSALS, {
    proposals,
  })
}

export const getSubscriptionSuccess = (subscription: any) => {
  return action(ActionTypes.GET_SUBSCRIPTION_SUCCESS, {
    subscription,
  })
}

export const closeSuccessMessage = () => {
  return action(ActionTypes.CLOSE_SUCCESS_MESSAGE)
}

export const getProjectsRequest = () => {
  return action(ActionTypes.GET_USER_PROJECTS_REQUEST)
}

export const getProjectsSuccess = (projectsList: ProjectsState['projectsList']) => {
  return action(ActionTypes.GET_USER_PROJECTS_SUCCESS, {
    projectsList,
  })
}
export const setPageDetails = (data: any) => {
  return action(ActionTypes.SET_PAGE_DETAILS, {
    data,
  })
}

export const getProjectsError = (message: ProjectsState['error']) => {
  return action(ActionTypes.GET_USER_PROJECTS_ERROR, {
    message,
  })
}

export const getArchivedProjectsRequest = () => {
  return action(ActionTypes.GET_ARCHIVED_PROJECTS_REQUEST)
}

export const getArchivedProjectsSuccess = (archivedProjects: ProjectsState['projectsList']) => {
  return action(ActionTypes.GET_ARCHIVED_PROJECTS_SUCCESS, {
    archivedProjects,
  })
}

export const getArchivedProjectsError = (message: ProjectsState['error']) => {
  return action(ActionTypes.GET_ARCHIVED_PROJECTS_ERROR, {
    message,
  })
}

export const postProjectSuccess = (data: Project) => {
  return action(ActionTypes.POST_PROJECT_SUCCESS, {
    data,
  })
}

export const postProjectError = (message: ProjectsState['error']) => {
  return action(ActionTypes.POST_PROJECT_ERROR, {
    message,
  })
}

export const editProjectSuccess = (data: Project) => {
  return action(ActionTypes.EDIT_PROJECT_SUCCESS, {
    data,
  })
}

export const editDrawingPageSucess = (data: drawingPage) => {
  return action(ActionTypes.EDIT_PAGE_SUCCESS, {
    data,
  })
}

export const deleteDrawingPageSuccess = (id: string, projectId: string) => {
  return action(ActionTypes.DELETE_PAGE_SUCCESS, {
    id,
    projectId,
  })
}

export const deleteArchivedProjectSuccess = (id: string) => {
  return action(ActionTypes.DELETE_ARCHIVED_PROJECT_SUCCESS, {
    id,
  })
}

export const restoreArchivedProjectSuccess = (id: string) => {
  return action(ActionTypes.RESTORE_ARCHIVED_PROJECT_SUCCESS, {
    id,
  })
}

export const restoreArchivedProjectError = (message: ProjectsState['error']) => {
  return action(ActionTypes.RESTORE_ARCHIVED_PROJECT_ERROR, {
    message,
  })
}

export const addDrawingPageSuccess = (data: drawingPage) => {
  return action(ActionTypes.ADD_PAGE_SUCCESS, {
    data,
  })
}

export const editProjectError = (message: ProjectsState['error']) => {
  return action(ActionTypes.EDIT_PROJECT_ERROR, {
    message,
  })
}

export const closeErrorMessage = () => {
  return action(ActionTypes.CLOSE_ERROR_MESSAGE)
}

export const deleteProjectSuccess = (id: string) => {
  return action(ActionTypes.DELETE_PROJECT_SUCCESS, {
    id,
  })
}

export const deleteProjectError = (message: ProjectsState['error']) => {
  return action(ActionTypes.DELETE_PROJECT_ERROR, {
    message,
  })
}

export const setShowInfo = (showAgain: boolean, page: editedPageProperties) => {
  return action(ActionTypes.SET_SHOW_INFO, {
    showAgain,
    page,
  })
}

export const setPageEdit = (edit: editProperties, page: editedPageProperties) => {
  return action(ActionTypes.SET_EDIT, {
    edit,
    page,
  })
}
export const addFolderSuccess = (data: ProjectFolder) => {
  return action(ActionTypes.ADD_FOLDER_SUCCESS, {
    data,
  })
}
export const deleteFolderError = (message: ProjectsState['error']) => {
  return action(ActionTypes.DELETE_FOLDER_ERROR, {
    message,
  })
}

export const deleteFolderSuccess = (folderId: string) => {
  return action(ActionTypes.DELETE_FOLDER_SUCCESS, {
    folderId,
  })
}

export const updateFolderSuccess = (data: ProjectFolder) => {
  return action(ActionTypes.UPDATE_FOLDER_SUCCESS, {
    data,
  })
}

export const getFolderSuccess = (data: ProjectFolder[]) => {
  return action(ActionTypes.GET_FOLDER_SUCCESS, {
    data,
  })
}
export const deleteProposalSuccess = (id: string) => {
  return action(ActionTypes.DELETE_PROPOSAL_SUCCESS, {
    id,
  })
}

export const getDrawingSetsSuccess = (data: DrawingSet[]) => {
  return action(ActionTypes.GET_DRAWING_SETS_SUCCESS, {
    data,
  })
}

export const addDrawingSetSuccess = (data: DrawingSet) => {
  return action(ActionTypes.ADD_DRAWING_SET_SUCCESS, {
    data,
  })
}

export const updateDrawingSetSuccess = (data: DrawingSet) => {
  return action(ActionTypes.UPDATE_DRAWING_SET_SUCCESS, {
    data,
  })
}

export const deleteDrawingSetSuccess = (setId: string) => {
  return action(ActionTypes.DELETE_DRAWING_SET_SUCCESS, {
    setId,
  })
}

export const setActiveDrawingSetSuccess = (projectId: string, drawingSetId: string | null) => {
  return action(ActionTypes.SET_ACTIVE_DRAWING_SET_SUCCESS, {
    projectId,
    drawingSetId,
  })
}

export const pageMetadataSuccess = (projectId: string, pages: drawingPage[]) => {
  return action(ActionTypes.PAGE_METADATA_SUCCESS, { projectId, pages })
}

export const pagesAddedSuccess = (projectId: string, pages: drawingPage[]) => {
  return action(ActionTypes.PAGES_ADDED_SUCCESS, { projectId, pages })
}
